package dev.akshaychordiya.pages.articles

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initFileTemplateForRecyclerviewAdapterInKotlinPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("articles/FileTemplateForRecyclerviewAdapterInKotlin.md", FrontMatterElement.Builder { addScalar("title", "File template for RecyclerView Adapter in Kotlin"); addScalar("date", "2018-02-01"); addScalar("description", "Android Studio is extremely powerful and has a lot of tricks under it’s sleeves which are waiting to be explored, one of which is File Templates."); addScalar("originalUrl", "https://proandroiddev.com/file-template-for-recyclerview-adapter-in-kotlin-4e31d2364842"); addScalar("originalName", "Medium"); addScalar("image", "/images/articles/file-template-for-recyclerview-adapter-in-kotlin/1lASZweVqr2OqyWd-pZiWVA.webp"); }))
}

@Page("/articles/file-template-for-recyclerview-adapter-in-kotlin")
@Layout(".components.layouts.ArticleLayout")
@Composable
fun FileTemplateForRecyclerviewAdapterInKotlinPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Android Studio is extremely powerful and has a lot of tricks under it’s sleeves which are waiting to be explored, one of which is File Templates.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("There are ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("several articles on this topic")
        }
        org.jetbrains.compose.web.dom.Text(" but in ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Java")
        }
        org.jetbrains.compose.web.dom.Text(" and I felt to take an opportunity do the same with Kotlin.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("steps-to-add-new-file-template") }) {
        org.jetbrains.compose.web.dom.Text("Steps to add new file template")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Note: If you already know how to create new file template, then you can directly jump to the RecyclerView Adapter template.")
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Press ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Ctrl + Shift + A")
            }
            org.jetbrains.compose.web.dom.Text(" (Windows) or ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Cmd + Shift + A")
            }
            org.jetbrains.compose.web.dom.Text(" (Mac) to open Action Window and type “Add Template”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Click on the “Plus” ➕ icon")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Give some name to the template and paste the following code")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/file-template-for-recyclerview-adapter-in-kotlin/1lASZweVqr2OqyWd-pZiWVA.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Add Template Window")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("RecyclerView Adapter Template code (Paste this):")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/d2180ad0fce47edc814b20e1b488b603/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After saving, and going to new file dialog; you’ll see the template which you created in the list, on clicking you’ll see the following dialog.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/file-template-for-recyclerview-adapter-in-kotlin/1Nx4fPzoZZSOQYOgl7A5Cdw.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("New RecyclerView Adapter wizard dialog")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Just enter all the details")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/file-template-for-recyclerview-adapter-in-kotlin/1pFyeZLamQ76UTmFAk41VVQ.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("New RecyclerView Adapter wizard dialog with details filled")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("That’s it! Now you can forget writing the same boilerplate again and again and instantly create an RecyclerView.Adapter in few seconds.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Feel free to give suggestions on making the template better.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/87c27c6bd6c8dea21c9726d9564b27d6/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://proandroiddev.com/file-template-for-recyclerview-adapter-in-kotlin-4e31d2364842") {
            org.jetbrains.compose.web.dom.Text("File template for RecyclerView Adapter in Kotlin")
        }
        org.jetbrains.compose.web.dom.Text(" was originally published in ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://proandroiddev.com") {
            org.jetbrains.compose.web.dom.Text("ProAndroidDev")
        }
        org.jetbrains.compose.web.dom.Text(" on Medium, where people are continuing the conversation by highlighting and responding to this story.")
    }
}
